import type { V6Kaart, V6Zaak } from "./api";

/** Groepen zonder antwoordvak met concept: daar vraagt het vak geen concept. */
export const ZONDER_CONCEPT = new Set(["live", "afgerond", "spam", "systeem"]);

/**
 * Sessie 72: de zaak uit de lijstkaart, zolang de echte zaak laadt. Kop,
 * kanaal en statuswoord staan er dan meteen; berichten en het antwoordvak
 * komen als de zaak binnen is (`laadt`).
 */
export function zaakUitKaart(kaart: V6Kaart): V6Zaak {
  return {
    zaak_id: kaart.zaak_id,
    // Een taakkaart heeft geen kanaal; de zaak toont dan mail, net als
    // `werkplek_v6.kanaal_woord` voor zo'n zaak.
    kanaal: kaart.kanaal === "taak" ? "mail" : kaart.kanaal,
    onderwerp: kaart.onderwerp,
    groep: kaart.groep,
    status_woord: kaart.status_woord,
    bron: null,
    wacht_sinds: kaart.wacht_sinds,
    stand: kaart.groep === "live" ? "live" : ZONDER_CONCEPT.has(kaart.groep) ? "afgerond" : "mail",
    klant_id: kaart.klant_id,
    gesprek_ids: kaart.gesprek_ids,
    berichten: [],
    beslis: null,
    bel: null,
    live: null,
    via: null,
    andere_open_zaken: [],
    klantkaart: null,
  };
}
